import debounce from "lodash/debounce";
import API from "serviceshift-ui/api-client";

import { helpers } from "@vuelidate/validators";
import { getAPIURL } from "../lib/helpers.js";

// Set api-client base url
API.init({
  API_BASE_URL: getAPIURL()
});

export const createUniqueEmailValidator = (initialValue = null) => {
  let pendingResolvers = [];

  const debouncedValidate = debounce(async (value) => {
    if (!value || value.trim() === "") {
      pendingResolvers.forEach((resolve) => resolve(true));
      pendingResolvers = [];
      return;
    }
    if (initialValue && value === initialValue) {
      pendingResolvers.forEach((resolve) => resolve(true));
      pendingResolvers = [];
      return;
    }

    try {
      await API.user.validateEmail({ email: value });
      pendingResolvers.forEach((resolve) => resolve(true));
    } catch {
      pendingResolvers.forEach((resolve) => resolve(false));
    }
    pendingResolvers = [];
  }, 750);

  return helpers.withAsync(
    helpers.withMessage("Email address already in use", (value) => {
      return new Promise((resolve) => {
        pendingResolvers.push(resolve);
        debouncedValidate(value);
      });
    })
  );
};

export const uniqueEmail = createUniqueEmailValidator();

export const createUniqueAccountEmailValidator = (emails) => {
  return helpers.withMessage("Emails must be unique.", (value) => {
    if (!value || value.trim() === "") return true;

    return emails.filter((email) => email.email_address === value).length < 2;
  });
};
